import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SiffiLanguagePickerComponent } from '../../../components/siffi-language-picker/siffi-language-picker.component';
import { Subscription } from 'rxjs';
import Session from '../../../utils/session.service';
import Config from '../../../utils/config.service';
import UserRestServices from '../../../services/user-rest.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import ScreeningEscalationRestService from '../../../services/screening-escalation-rest.service';

@Component({
	standalone: true,
	selector: 'verify-email',
	templateUrl: './verify-email.component.html',
	imports: [ CommonModule, TranslateUnauthenticatedPipe, FormsModule, RouterLink, SiffiLanguagePickerComponent ]
})
export default class VerifyEmailView implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private screeningRest: ScreeningEscalationRestService = inject(ScreeningEscalationRestService);

	vm: any = undefined;
	private titleSubscription: Subscription = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		var origin: any = 'siffi.com';
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();

		this.vm.isSuccess = false;
		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = queryParams['locale'] || 'en_GB';
		this.vm.localeParams = this.vm.locale ? { locale: this.vm.locale } : undefined;
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.config.getSettings().DeviceLanguages[origin];
		this.vm.languages = this.config.getSettings().Languages;
		this.vm.email = queryParams['email'];
		this.vm.verificationCode = queryParams['verificationCode'];
		this.vm.registrationToken = queryParams['rt'];
		this.vm.type = queryParams['type'] || 'NONE';
		this.vm.isSuccessIndividualUser = false;
		if (this.vm.registrationToken) {
			this.clearScreeningAutoLogin();
		}
		var currentSession = this.session.getSession();
		this.vm.isAuthenticated = !!currentSession && !this.vm.registrationToken;
		if (this.vm.isAuthenticated) {
			this.angularRoutingHelperService.home(currentSession.user);
			return;
		}

		this.vm.setLocale = this.setLocale;
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.navigateToPlatform = this.navigateToPlatform;
		this.vm.completeScreeningRegistration = this.completeScreeningRegistration;

		if (this.vm.registrationToken) {
			this.vm.isScreeningCompletion = true;
			this.userRestServices.getScreeningPendingRegistration({
				verificationToken: this.vm.registrationToken
			}).then((response) => {
				this.vm.pendingRegistration = response.body || {};
			}).catch(() => {
				this.vm.showError = true;
			});
		} else if (this.vm.email && this.vm.verificationCode && this.vm.type) {
			this.verifyEmail(this.vm.email, this.vm.verificationCode, this.vm.type);
		}

		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('VerifyEmail.VerifyEmail_Title');
	};

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}

	completeScreeningRegistration() {
		if (!this.vm.registrationToken) return;
		if (!this.vm.password || this.vm.password.length < 8) {
			this.vm.passwordError = 'Screening.Pilot.Verify.Password_Error';
			return;
		}
		if (this.vm.password !== this.vm.passwordConfirm) {
			this.vm.passwordError = 'Screening.Pilot.Verify.Password_Mismatch';
			return;
		}
		this.vm.passwordError = undefined;
		this.vm.loading = true;
		this.userRestServices.createScreeningAccount({
			verificationToken: this.vm.registrationToken,
			newUserPassword: this.vm.password,
			deviceLanguage: this.vm.locale
		}).then((response) => {
			this.vm.loading = false;
			this.vm.isSuccess = true;
			this.vm.showError = false;
			this.screeningRest.clearPilotContext();
			this.clearScreeningAutoLogin();
		}).catch(() => {
			this.vm.loading = false;
			this.vm.showError = true;
			this.vm.isSuccess = false;
		});
	}

	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl('siffi.com', this.vm.locale);
	}

	navigateToPlatform() {
		this.userRestServices.logout(undefined, () => {
			this.session.removeSessionCookie();
			this.angularRoutingHelperService.setPath('/login', false, true, this.vm.localeParams);
		}, () => {
			this.session.removeSessionCookie();
			this.angularRoutingHelperService.setPath('/login', false, true, this.vm.localeParams);
		});
	}

	private clearScreeningAutoLogin() {
		this.session.removeSessionCookie();
		this.userRestServices.logout(undefined, () => {
			this.session.removeSessionCookie();
		}, () => {
			this.session.removeSessionCookie();
		});
	}

	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}

	verifyEmail(email, verificationCode, type) {
		if (type === 'BUSINESS') {
			this.userRestServices.confirmBusinessEmail({
				email: email,
				verificationCode: verificationCode,
				language: this.vm.locale
			}).then((response) => {
				console.log(response);
				this.vm.loading = true;
				if (response.status === 200) {
					this.vm.loading = false;
					this.vm.isSuccess = true;
				}
			}).catch((response) => {
				console.log(response);
				if (response && response.error && response.error.header) {
					if (response.error.header === "PASSWORD_RESET_REQUIRED") {
						location.href = response.error.content;
					}
				} else {
					this.vm.loading = false;
					this.vm.isSuccess = false;
				}
				this.vm.loading = false;
				this.vm.showError = true;
			});
		} else {
			this.userRestServices.confirmEmail({
				email: email,
				verificationCode: verificationCode
			}).then((response) => {
				console.log(response);
				this.vm.loading = false;
				this.vm.isSuccess = true;
				this.vm.isSuccessIndividualUser = true;
			}).catch((response) => {
				this.vm.loading = false;
				this.vm.showError = true;
				this.vm.isSuccess = false;
			});
		}
	}

}
